import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import getEnvironmentSalmGroups from 'api/Environment/getEnvironmentSamlGroups';

type EnvironmentGroups = {
    [key: string]: string[];
};

type SelectObject = {
    name: string;
    label: string;
};
type GroupName = {
    name: string;
    environmentGroups: string[];
};

const groupMappings: Record<string, string> = {
    originSamlBasicDevGroupName: 'BasicDev',
    originSamlFullDevGroupName: 'FullDev',
    originSamlGroupName: 'Admin',
    originSamlReaderGroupName: 'Reader',
};
export default function useEnvSalmGroups(environmentUri: string) {
    const client = useClient();

    const { openAlert } = useAlert();
    const [loading, setLoading] = useState(true);
    const [roleOptions, setRoleOptions] = useState<GroupName[]>([]);
    const [groupsOptions, setGroupOptions] = useState<SelectObject[]>([]);
    useEffect(() => {
        const fetchGroups = async () => {
            setLoading(true);

            if (environmentUri) {
                const response = await client.query(
                    getEnvironmentSalmGroups(environmentUri),
                );

                if (!response.errors) {
                    delete response.data.getEnvironment.__typename;

                    const environmentGroups: EnvironmentGroups =
                        response.data.getEnvironment;

                    const groupNames: GroupName[] = Object.entries(
                        environmentGroups,
                    ).map(([key, groups]) => ({
                        name: groupMappings[key],
                        environmentGroups: groups,
                    }));

                    const allGroups: SelectObject[] = Object.values(
                        environmentGroups,
                    )
                        .flat()
                        .map((group) => ({
                            label: group,
                            name: group,
                        }));
                    setGroupOptions(allGroups);

                    setRoleOptions(groupNames);
                } else {
                    openAlert({
                        message: 'Groups could not retrieved',
                        severity: 'alert',
                    });
                }
            }
            setLoading(false);
        };

        if (client) {
            fetchGroups();
        }
    }, [client, environmentUri]);

    return {
        loading,
        roleOptions,
        groupsOptions,
    };
}
